import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceProviderResponseModel, ShippingAddress } from 'src/app/shared/models';
import { ConfirmCancelModalComponent } from '../../../shared/components/confirm-cancel-modal/confirm-cancel-modal.component';
import { OrderService } from '../../../shared/services';

@Component({
  selector: 'app-shipping-final',
  templateUrl: './shipping-final.component.html',
  styleUrls: ['./shipping-final.component.scss']
})
export class ShippingFinalComponent implements OnInit {

  returUrl = this.activatedRoute.snapshot.queryParams.returUrl;
  orderId = this.activatedRoute.snapshot.queryParams.orderId;

  params: Params;
  @Input() idDelivery: string;
  next = false;
  @Input() shippingAddress: ShippingAddress;
  @Input() serviceProviderResponse: ServiceProviderResponseModel;
  @Output() payOrder = new EventEmitter();
  @Input() loading: boolean;
  @Input() option: any;

  termsCheck: boolean;
  carrierTermsCheck: boolean;
  expanded: boolean = false;

  translatePath = "public.shipping-final.";
  constructor(
    public serviceOrder: OrderService,
    public activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    public modalService: NgbModal

  ) { }

  ngOnInit(): void {
    this.params = this.activatedRoute.snapshot.queryParams;
  }

  pay(): void {
    const returUrl = this.activatedRoute.snapshot.queryParams.returUrl;
    if (this.termsCheck === undefined || this.carrierTermsCheck === undefined) {
      this.termsCheck = false;
      this.carrierTermsCheck = false;
    } else if (this.termsCheck && this.carrierTermsCheck) {
      this.next = true;
      this.payOrder.emit();
    }
  }

  cancel(): void {
    const modalRef = this.modalService.open(ConfirmCancelModalComponent);
    modalRef.result.then((response: string) => {
      if (response === 'confirmed') {
        location.replace(`${this.returUrl}?orderId=${this.orderId}`);
      } else {
        return;
      }
    });

  }

}
